import { useState, useEffect } from 'react';
import { api } from '../api';
import ValueBadge from '../components/ValueBadge';

export default function SweetSpots() {
  const [spots, setSpots] = useState([]);
  const [filterSource, setFilterSource] = useState('');
  const [filterCabin, setFilterCabin] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = {};
    if (filterSource) params.source = filterSource;
    if (filterCabin) params.cabin = filterCabin;
    api.getSweetSpots(params).then(setSpots).catch(() => {}).finally(() => setLoading(false));
  }, [filterSource, filterCabin]);

  return (
    <div className="space-y-6 pb-16">
      <div>
        <h1 className="text-2xl font-bold">Sweet Spots</h1>
        <p className="text-brand-ink/70 text-sm mt-1">The best bang for your points — high-value redemptions across programs.</p>
      </div>

      {/* Filters */}
      <div className="flex flex-wrap gap-3">
        <select
          value={filterSource}
          onChange={e => setFilterSource(e.target.value)}
          className="bg-navy-lighter border border-brand-ink/10 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-teal"
        >
          <option value="">All Programs</option>
          <option value="amex_mr">Amex MR Only</option>
          <option value="chase_ur">Chase UR Only</option>
        </select>
        <select
          value={filterCabin}
          onChange={e => setFilterCabin(e.target.value)}
          className="bg-navy-lighter border border-brand-ink/10 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-teal"
        >
          <option value="">All Classes</option>
          <option value="business">Business</option>
          <option value="first">First</option>
          <option value="hotel">Hotels</option>
        </select>
      </div>

      {loading ? (
        <div className="text-brand-ink/65 text-center py-12">Loading sweet spots…</div>
      ) : (
        <div className="space-y-4">
          {spots.map((spot, i) => (
            <div key={spot.id} className="bg-navy-light rounded-xl border border-brand-ink/10 p-5 hover:border-brand-ink/20 transition">
              <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-3">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-lg font-bold">{spot.airline_program}</span>
                    <ValueBadge cpp={parseFloat(spot.cents_per_point)} />
                    {i === 0 && <span className="text-xs bg-teal/20 text-teal px-2 py-0.5 rounded-full font-bold">BEST VALUE</span>}
                  </div>
                  <div className="text-sm text-brand-ink/70">
                    {spot.origin_region} &rarr; {spot.destination_region} &middot; {spot.cabin_class}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-xl font-bold">
                    {spot.points_cost_one_way ? `${spot.points_cost_one_way.toLocaleString()}/OW` : 'RT pricing'}
                  </div>
                  <div className="text-xs text-brand-ink/65">Cash price: ${spot.typical_cash_price_one_way?.toLocaleString()}</div>
                </div>
              </div>

              <p className="text-sm text-brand-ink/80 mb-3">{spot.description}</p>

              {/* Source programs */}
              <div className="flex flex-wrap gap-2 mb-3">
                {spot.source_programs?.includes('amex_mr') && (
                  <span className="text-xs px-2 py-0.5 bg-blue-900/50 text-blue-300 rounded">Amex MR</span>
                )}
                {spot.source_programs?.includes('chase_ur') && (
                  <span className="text-xs px-2 py-0.5 bg-indigo-900/50 text-indigo-300 rounded">Chase UR</span>
                )}
                {spot.requires_round_trip && (
                  <span className="text-xs px-2 py-0.5 bg-gold/20 text-gold rounded">Round-trip required</span>
                )}
              </div>

              {spot.restrictions && (
                <div className="text-xs text-brand-ink/65 mb-2">
                  <strong className="text-brand-ink/70">Restrictions:</strong> {spot.restrictions}
                </div>
              )}

              <details className="group">
                <summary className="text-sm text-teal font-medium cursor-pointer hover:underline">Booking Instructions</summary>
                <div className="mt-2 text-sm text-brand-ink/75 bg-brand-ink/5 rounded-lg p-3">
                  {spot.booking_instructions}
                </div>
              </details>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
